import { CellContext } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";
import { Badge } from "@bcc/components/ui/badge";
import { VariantWithProductData } from "../types";
import { setSourceCellTestId } from "../products-table.utils";

const SOURCE_SHOPIFY = "shopify";
const SOURCE_WOOCOMMERCE = "woocommerce";

const getSourceBadgeStyles = (source: string | undefined) => {
  if (source === SOURCE_SHOPIFY) {
    return "bg-green-500/10 text-green-700 dark:text-green-400 border-green-500/30";
  }
  if (source === SOURCE_WOOCOMMERCE) {
    return "bg-purple-500/10 text-purple-700 dark:text-purple-400 border-purple-500/30";
  }
  return "bg-gray-500/10 text-gray-700 dark:text-gray-400 border-gray-500/30";
};

interface SourceCellProps {
  isFirstVariant?: boolean;
}

export const SourceCellMarkup = (props: CellContext<VariantWithProductData, unknown> & SourceCellProps) => {
  const { t } = useTranslation();
  const data = props.row.original;
  const isFirstVariant = props.isFirstVariant ?? true;

  let sourceLabel = t("views.productsTable.source.manual");
  if (data.source === SOURCE_SHOPIFY) {
    sourceLabel = t("views.productsTable.source.shopify");
  } else if (data.source === SOURCE_WOOCOMMERCE) {
    sourceLabel = t("views.productsTable.source.woocommerce");
  }

  return (
    <div data-testid={setSourceCellTestId(props.row.index)}>
      {isFirstVariant && (
        <Badge variant="outline" className={getSourceBadgeStyles(data.source)}>
          {sourceLabel}
        </Badge>
      )}
    </div>
  );
};
